import type {endOfDay, startOfDay} from 'date-fns';
import {fromZonedTime, toZonedTime} from 'date-fns-tz';

type DateModifier = typeof startOfDay | typeof endOfDay;

export const getUTCDate = (date: string | number | Date = new Date()) =>
	toZonedTime(date, 'UTC');

// TODO rename
// TODO use function as string
export const utcModifierWrapper = (
	date: Date,
	modifier: DateModifier,
	timeZone: string | undefined,
) => {
	if (!timeZone) {
		return modifier(date);
	}

	// To zoned time
	const dateZoned = toZonedTime(date, 'UTC');

	// Apply modifier
	const modifierDateZoned = modifier(dateZoned);

	// To UTC time
	return fromZonedTime(modifierDateZoned, 'UTC');
};

export const toUTCTimestamp = (value: string | number | Date): number => {
	if (typeof value === 'number') {
		return value;
	}

	if (value instanceof Date) {
		return value.getTime();
	}

	const [datePart, timePart = '00:00:00'] = value.trim().split(/[ T]/);

	const [year, month, day] = datePart.split('-').map(Number);

	const [hour = 0, minute = 0, second = 0] = timePart.split(':').map(Number);

	if (!year || !month || !day) {
		return new Date(value).getTime();
	}

	return Date.UTC(year, month - 1, day, hour, minute, second);
};
